// extracted by mini-css-extract-plugin
module.exports = {"object_info__section":"index_object_info__section__1MAF_","object_info__border":"index_object_info__border__-lnGF","object_info__content":"index_object_info__content__3qEbu"};